<template>
  <yd-dialog :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
    <template slot="title">
      <span>详细接单情况说明</span>
      <span class="color-redFont">{{ tip }}</span>
    </template>
    <div id="amapContainer" class="map"></div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">返 回</el-button>
    </span>
  </yd-dialog>
</template>

<script >
import { ref, nextTick } from '@vue/composition-api';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const AMap = window.AMap;
  let map = null;
  const dialogVisible = ref(false);
  const initData = ref({});
  const tip = ref('');
  const init = row => {
    tip.value = '';
    initData.value = row;
    dialogVisible.value = true;
    nextTick(() => {
      intAmap();
    });
  };
  const handleClose = row => {
    dialogVisible.value = false;
  };
  const intAmap = () => {
    map = new AMap.Map('amapContainer', {
      zoom: 14,
      // 初始化地图层级
      resizeEnable: true
    });
    const carIcon = new AMap.Icon({
      size: new AMap.Size(56, 62),
      image: require('../img/car.png'),
      imageSize: new AMap.Size(56, 62)
    });
    const orderIcon = new AMap.Icon({
      size: new AMap.Size(56, 62),
      image: require('../img/order.png'),
      imageSize: new AMap.Size(56, 62)
    });
    const {
      longitude = '',
      latitude = '',
      location = '',
      userLongitude = '',
      userLatitude = '',
      type = '',
      operationTime = ''
    } = initData.value;
    const driverPos = new AMap.Marker({
      icon: carIcon,
      position: [longitude, latitude]
    });
    const customPos = new AMap.Marker({
      icon: orderIcon,
      position: [userLongitude, userLatitude]
    });
    let posArr = [];
    if (type) {
      if (location && location !== '未知位置') {
        posArr = [driverPos, customPos];
      } else {
        tip.value = '（没有获取到司机位置）';
        posArr = [customPos];
      }
    } else {
      posArr = [driverPos];
    }
    map.add(posArr);
    map.setFitView(posArr);
    if (!type) {
      return;
    }
    const text = setDriverText(type);
    driverPos.setLabel({
      direction: 'top',
      content: `
      <div class="color-fff flex" style="padding: 3px">
        <span class="margin-right-10">${text}</span>
        <span>${operationTime}</span>
      </div>`
    });
  };
  const setDriverText = type => {
    if (type === 'one') {
      return '出发接人';
    }
    if (type === 'two') {
      return '到达上车点';
    }
    if (type === 'three') {
      return '乘客上车';
    }
    return '到达目的地';
  };
  return Object.assign({
    dialogVisible,
    tip,
    handleClose
  }, {
    init
  });
};
export default __sfc_main;
</script>

<style lang="scss" scoped>
  .map {
    width: 100%;
    height: 50vh;
  }
  ::v-deep .amap-marker-label {
    background: rgba(0, 0, 0, 0.7);
    border-radius: 8px;
  }
</style>
